import { createApi } from '@reduxjs/toolkit/query/react';
import { createBaseQuery } from 'helpers/api';

export const savedViewsApi = createApi({
  reducerPath: 'savedViewsApi',
  baseQuery: createBaseQuery('saved_views'),
  tagTypes: ['SavedView'],
  endpoints: builder => ({
    getSavedViews: builder.query({
      query: () => '/',
      transformResponse: ({ result }) => result,
      providesTags: ['SavedView'],
    }),
    createSavedView: builder.mutation({
      query: data => ({ url: '/', method: 'POST', body: data }),
      transformResponse: ({ result }) => result,
      invalidatesTags: ['SavedView'],
    }),
    updateSavedView: builder.mutation({
      query: ({ id, ...data }) => ({ url: `/${id}`, method: 'PUT', body: data }),
      transformResponse: ({ result }) => result,
      async onQueryStarted({ id, ...patch }, { dispatch, queryFulfilled }) {
        if (!Object.prototype.hasOwnProperty.call(patch, 'is_default')) return;
        const isDefault = !!patch.is_default;
        const idNum = Number(id);
        const patchResult = dispatch(
          savedViewsApi.util.updateQueryData('getSavedViews', undefined, draft => {
            if (!Array.isArray(draft)) return;
            const target = draft.find(v => Number(v.id) === idNum);
            if (!target) return;
            const { type, user_id: userId, company_id: companyId } = target;
            if (isDefault) {
              draft.forEach(v => {
                if (
                  v.type === type &&
                  Number(v.user_id) === Number(userId) &&
                  Number(v.company_id) === Number(companyId)
                ) {
                  v.is_default = Number(v.id) === idNum;
                }
              });
            } else {
              target.is_default = false;
            }
          }),
        );
        try {
          await queryFulfilled;
        } catch {
          patchResult.undo();
        }
      },
      invalidatesTags: ['SavedView'],
    }),
    deleteSavedView: builder.mutation({
      query: id => ({ url: `/${id}`, method: 'DELETE' }),
      invalidatesTags: ['SavedView'],
    }),
  }),
});

export const {
  useGetSavedViewsQuery,
  useCreateSavedViewMutation,
  useUpdateSavedViewMutation,
  useDeleteSavedViewMutation,
} = savedViewsApi;
